import React, { useEffect, useState, useRef } from 'react';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { HemaHeadingWithSubText, HemaLabel, Button, Alert } from '../utils';
import { EyeIcon, CrossIcon, PassLock, HideEye, GreenCheck, RedClose } from '../HemeIconLibrary';
import { showErrorReducer } from '../Store/reducers/uiSettings';
import { resetPasswordForForgetAction, SavePasswordForInviteAction } from '../Actions/auth';
import LoginInput from '../utils/FormElements/loginInput';

const Index = ({ token, setVerifyLink, allAnsweredQuestions, title, description, type }) => {
  const [showPassword, setshowPassword] = useState(false);
  const [showPassword1, setshowPassword1] = useState(false);
  const formikRef = useRef();
  const dispatch = useDispatch();

  return (
    <div className="max-w-[450px] relative">
      <HemaHeadingWithSubText heading={title} sub={description} subTextColor="#595959" />
      <Formik
        initialValues={{
          password: '',
          confirmPassword: '',
        }}
        innerRef={formikRef}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          if (!values.password) {
            errors.password = 'Required';
          } else if (!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/i.test(values.password)) {
            errors.password = (
              <div className="w-full p-[16px] border border-solid border-[#DEE2E6] rounded-lg shadow-mdShadow mt-[11px] bg-white absolute left-0 z-10">
                <h1 className="font-bold text-sm text-[#454545] mb-[13px]">Password must contain the following:</h1>
                <div className="w-full flex flex-col gap-[5px]">
                  <div className="flex items-center gap-1">
                    {!/^(?=.*?[a-z])/.test(values.password) ? <RedClose /> : <GreenCheck />}
                    <p className={`font-bold text-xs m-0 ${!/^(?=.*?[a-z])/.test(values.password) ? 'text-[#D44040]' : 'text-[#138846]'}`}>At least one lowercase letter (a-z)</p>
                  </div>

                  <div className="flex items-center gap-1">
                    {!/^(?=.*?[A-Z])/.test(values.password) ? <RedClose /> : <GreenCheck />}
                    <p className={`font-bold text-xs m-0 ${!/^(?=.*?[A-Z])/.test(values.password) ? 'text-[#D44040]' : 'text-[#138846]'}`}>At least one uppercase letter (A-Z)</p>
                  </div>

                  <div className="flex items-center gap-1">
                    {!/^(?=.*?[0-9])/.test(values.password) ? <RedClose /> : <GreenCheck />}
                    <p className={`font-bold text-xs m-0 ${!/^(?=.*?[0-9])/.test(values.password) ? 'text-[#D44040]' : 'text-[#138846]'}`}>At least one number (0-9)</p>
                  </div>
                  <div className="flex items-center gap-1">
                    {!/^(?=.*?[#?!@$%^&*-])/.test(values.password) ? <RedClose /> : <GreenCheck />}
                    <p className={`font-bold text-xs m-0 ${!/^(?=.*?[#?!@$%^&*-])/.test(values.password) ? 'text-[#D44040]' : 'text-[#138846]'}`}>
                      At least one special character (~!@#$
                      <br /> %^&*)
                    </p>
                  </div>
                  <div className="flex items-center gap-1">
                    {values.password.length < 8 ? <RedClose /> : <GreenCheck />}
                    <p className={`font-bold text-xs m-0 ${values.password.length < 8 ? 'text-[#D44040]' : 'text-[#138846]'}`}>At least 8 characters</p>
                  </div>
                </div>
              </div>
            );
          }
          if (!values.confirmPassword) {
            errors.confirmPassword = 'Required';
          }
          if (values.confirmPassword !== values.password) {
            errors.confirmPassword = 'confirm password not matched';
          }
          dispatch(showErrorReducer(''));
          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true);
          if (type === 'reset-password') {
            const result = await resetPasswordForForgetAction({
              passwordResetToken: token,
              questions: allAnsweredQuestions,
              password: values.password,
            });
            setSubmitting(false);
            if (result?.status === 200) {
              setVerifyLink('set-pass-success');
            }
          } else if (type === 'new-password') {
            const result = await SavePasswordForInviteAction({
              invitationToken: token,
              password: values.password,
            });
            setSubmitting(false);
            if (result?.status === 200) {
              setVerifyLink('set-questions');
            }
          } else {
            setSubmitting(false);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          /* and other goodies */
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <div className="mt-[24px]">
                <Alert type="error" />
              </div>

              <div className="flex flex-col mb-[15px]">
                <HemaLabel text="New Password" Icon={<PassLock />} textSize="text-[16px]" />
                <LoginInput
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Enter Password"
                  inputIcon={values.password ? !showPassword ? <EyeIcon /> : <HideEye />: ""}
                  crossIcon={values.password ? <CrossIcon /> : ''}
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setshowPassword={setshowPassword}
                  showPassword={showPassword}
                  setFieldValue={setFieldValue}
                />
                <p className="error m-0  text-[#F54C3B] ">{errors.password && errors.password}</p>
              </div>
              <div className="flex flex-col mb-[15px]">
                <HemaLabel text="Confirm New Password" Icon={<PassLock />} textSize="text-[16px]" />
                <LoginInput
                  type={showPassword1 ? 'text' : 'password'}
                  name="confirmPassword"
                  placeholder="Enter Password"
                  inputIcon={values.confirmPassword  ? !showPassword1 ? <EyeIcon /> : <HideEye />: ""}
                  crossIcon={values.confirmPassword ? <CrossIcon /> : ''}
                  value={values.confirmPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setshowPassword={setshowPassword1}
                  showPassword={showPassword1}
                  setFieldValue={setFieldValue}
                />

                <p className="error m-0  text-[#F54C3B] ">{errors.confirmPassword && touched.confirmPassword && errors.confirmPassword}</p>
              </div>

              {isSubmitting ? (
                <Button
                  type="submit"
                  bg="bg-primary1"
                  className="w-full h-[48px] justify-center font-semibold"
                  text={
                    <>
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                    </>
                  }
                />
              ) : (
                <Button text="Save Password" disabled={Object.keys(errors)?.length ?  true : false} type="submit" bg="bg-primary1" border="border-primary1" color="text-white" className="w-full h-[48px] justify-center font-semibold" />
              )}
            </form>
          </>
        )}
      </Formik>
    </div>
  );
};

export default Index;
